import React from "react";
import "../styles/Skills.scss";

export function Skills() {
  return (
    <section id="skills" className="skills">
      <h3>TECHNICAL SKILLS</h3>
      <div className="underline-decoration"></div>
      <div className="list-container">
        <div className="right-border">
          <h4>Language</h4>
          <ul>
            <li>HTML</li>
            <li>CSS</li>
            <li>Javascript</li>
            <li>SQL</li>
            <li>Java</li>
          </ul>
        </div>
        <div className="right-border">
          <h4>Front End</h4>
          <ul>
            <li>React</li>
            <li>React Native</li>
            <li>Redux</li>
            <li>Hooks</li>
            {/* <li></li> */}
          </ul>
        </div>
        <div className="right-border">
          <h4>Back End</h4>
          <ul>
            <li>Node</li>
            <li>Express</li>
            <li>Spring-Boot</li>
            <li>Postgresql</li>
            <li>AWS</li>
          </ul>
        </div>
        <div className="no-border">
          <h4>Testing</h4>
          <ul>
            <li>Jest</li>
            <li>Testing Library</li>
            <li>Rest Assured</li>
            <li>Cypress</li>
            <li>Spring-Boot-Test</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
